import EbComsConfig from "./config";
import EbComsDesign from "./design";
import EbComsView from "./view";
import MEbComsConfig from "./config-m";
import MEbComsDesign from "./design-m";
import MEbComsView from "./view-m";

export default {
  Design: EbComsDesign,
  View: EbComsView,
  Config: EbComsConfig,
  MDesign: MEbComsDesign,
  MView: MEbComsView,
  MConfig: MEbComsConfig,
};
